import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';

import { OnlineMenuVirtualLocationsEffects } from './online-menu-virtual-locations.effects';
import { onlineMenuVirtualLocationsReducer } from './online-menu-virtual-locations.reducer';

@NgModule({
    declarations: [],
    imports: [CommonModule, StoreModule.forFeature('onlineMenuVirtualLocations', onlineMenuVirtualLocationsReducer), EffectsModule.forFeature([OnlineMenuVirtualLocationsEffects])],
    exports: [],
    providers: [],
})
export class OnlineMenuVirtualLocationsStateModule {}
